import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Grid, Box, styled, Stack } from '@mui/material';
import { timeSince, WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';

import { extractContent } from '../../../SentEmailLogs';
import { extractEmail, getTimeString, IConfiguredAccountsDTO } from '../../helper';
import { ImapSearchResponse } from '../hooks/useSearch';

import { SearchEmailAttachments } from './SearchEmailAttachments';
type InboxContentProps = {
  emailContent: ImapSearchResponse;
  configuredAccount: IConfiguredAccountsDTO;
};

export const IFrame = styled('iframe')(() => ({
  height: '550px',
  width: '100%',
  border: 0,
  overflowY: 'auto',
}));

export const SearchEmailContent = ({ emailContent, configuredAccount }: InboxContentProps) => {
  const toList = `${extractContent(emailContent.to.join(',')).toString()}`
    .split(',')
    .filter((email) => email != configuredAccount.recruiterEmail)
    .join();
  return (
    <Grid sx={{ overflowY: 'auto' }} container xs={8}>
      <Box bgcolor="white" borderColor="text.primary" position="relative" width="100%">
        <Box sx={{ display: 'flex' }}>
          <Box margin={1} justifyContent="center" alignItems="center">
            <AccountCircleIcon sx={{ fontSize: '4rem' }} />
          </Box>
          <Box sx={{ display: 'inline-block' }}>
            <Grid container>
              <Grid>
                <Stack direction="row" justifyContent="flex-start" pt={1} pb={1}>
                  <WsTypography color={WsTypoColors.PRIMARY} variant={WsTypoVariants.BODY1}>
                    To : {configuredAccount.recruiterName}({configuredAccount.recruiterEmail}),
                    {toList}...
                  </WsTypography>
                </Stack>
              </Grid>
              <Stack pt={1} pb={1} direction="row" justifyContent="flex-start">
                <WsTypography color={WsTypoColors.SENARY} variant={WsTypoVariants.BODY1}>
                  From : {extractEmail(emailContent.from).email}
                </WsTypography>
              </Stack>
              <Grid pt={1} pb={1} ml={1}>
                <WsTypography color={WsTypoColors.QUATERNARY} variant={WsTypoVariants.SUB_TITLE}>
                  {getTimeString(emailContent.createdOn)}(
                  {timeSince(String(emailContent.createdOn))})
                </WsTypography>
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Grid item xs={12} position="relative" pl="1.5em" pr="0.5em" pt="2em">
          {emailContent && <div dangerouslySetInnerHTML={{ __html: emailContent.body ?? 'NA' }} />}

          <Box marginTop="5em" bottom={0}>
            {SearchEmailAttachments(emailContent, configuredAccount).map((item) => item)}
          </Box>
        </Grid>
      </Box>
    </Grid>
  );
};
